<div class="flex mt-2 mb-2 px-4 md:px-0 w-full">
  <div class="grid md:grid-cols-[auto,1fr] md:gap-8 w-full">

    <div class="hidden md:flex items-start self-start md:-ml-4 md:-mt-2">
      <div class="w-14 h-14 md:w-16 md:h-16">
        <app-ivy-face-animated></app-ivy-face-animated>
      </div>
    </div>


    <div class="bg-white/50 backdrop-blur-sm rounded-[10.4px] shadow-sm border border-white overflow-visible
                w-full md:inline-block md:w-auto md:max-w-xl p-4">

      <div class="flex items-start gap-0 justify-start md:hidden">
        <div class="shrink-0 -ml-4 -mt-4" [style.width.px]="70" [style.height.px]="70">
          <app-ivy-face-animated [size]="70"></app-ivy-face-animated>
        </div>
        <div class="min-w-0">
          <h2 class="text-sm font-semibold text-gray-900 leading-tight">Ask Health Assistant</h2>
          <p class="text-xs text-gray-700 leading-snug pt-1">
            I’m here to help, let me know what I can help you with or start typing in the text field.
          </p>
        </div>
      </div>

      <div class="hidden md:block">
        <h2 class="text-base font-semibold text-gray-900">Ask Health Assistant</h2>
        <p class="text-sm text-gray-700 leading-snug">
          I’m here to help, let me know what I can help you with or start typing in the text field.
        </p>
      </div>

      <div class="mt-3 md:mt-4">
        <div class="flex flex-wrap px-1 md:px-0 justify-start gap-1.5 md:gap-2">
          @for (choice of choices; track choice) {
            <button (click)="select(choice.option)" [class]="getOptionClass(choice.option)"
              class="px-2.5 md:px-3 py-1.5 md:py-2 rounded-full text-[11px] md:text-xs font-medium text-gray-800 border hover:bg-purple-50 transition-colors">
              <span class="inline-flex items-center gap-1 justify-start">
                <span>{{ choice.emoji ?? '' }}</span>
                <span>{{ choice.option.display }}</span>
              </span>
            </button>
          }
        </div>
      </div>

    </div>
  </div>
</div>
